"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reloadStoreListOnDisconnect = void 0;

var _mergeMap = require("rxjs/operators/mergeMap");

var _of = require("rxjs/observable/of");

var _actions = require("settings-ui-sdk/Ecommerce/actions");

var _actions2 = require("settings-ui-sdk/EcommerceV2/actions");

var _settingsInteractions = require("../actions/settingsInteractions");

var reloadStoreListOnDisconnect = function reloadStoreListOnDisconnect($action) {
  return $action.ofType(_actions.DisconnectShopifyActionTypes.SUCCESS).pipe((0, _mergeMap.mergeMap)(function () {
    return (0, _of.of)((0, _actions2.loadStores)(), (0, _settingsInteractions.selectStore)());
  }));
};

exports.reloadStoreListOnDisconnect = reloadStoreListOnDisconnect;